import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import React from 'react';

export const icon = <CheckBoxOutlineBlankIcon />;
export const checkedIcon = <CheckBoxIcon />;
